import React from "react";
import { Box, Grid2 } from "@mui/material";
import styles from '../../pages/V2Pages/my-learnings/MyLearnings.module.scss'
import CustomSkeleton from "../../components/custom-skeleton/CustomSkeleton";

const LearningContentSkeleton: React.FC = () => {

  return (
    <Box zIndex={3} p={2} margin={'auto'} maxWidth={"1440px"}>
        
        <Box className={styles.categorySection}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
            mx={2}
          >
            <CustomSkeleton
              variant="rectangular"
              width="20%"
              height={40}
              className={styles.buttonSkeleton}
            />
          </Box>

          <Grid2 container spacing={3} px={2}>
            {Array.from({ length: 3 }).map((_, idx) => (
              <Grid2 key={idx} size={{ xs: 12, sm: 12, md: 4 }}>
                <CustomSkeleton
                  variant="rectangular"
                  width="100%"
                  sx={{
                    borderRadius: "16px",
                    height: {
                      xs: 150,
                      md: 250,
                    },
                  }}
                />
              </Grid2>
            ))}
          </Grid2>

          <Grid2 container spacing={3} p={2}>
            {Array.from({ length: 3 }).map((_, idx) => (
              <Grid2 key={idx} size={{ xs: 12, sm: 12, md: 4 }}>
                <CustomSkeleton
                  variant="rectangular"
                  width="100%"
                  sx={{
                    borderRadius: "16px",
                    height: {
                      xs: 150,
                      md: 250,
                    },
                  }}
                />
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </Box>
  );
};

export default LearningContentSkeleton;

